<template>
  <div class="constructor_scroll">
    <div class="container-block" v-if="isLoaded" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle" >
        <div class="breadcrumbs">
          <router-link to="/description-pages">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{item.object['title.1']}} {{item.object['title.2']}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Редактирование страницы</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Первая строка" name="titleFirst"></new-input>
              <new-input title="Вторая строка" name="titleSecond"></new-input>
              <new-input title="Ссылка" name="url"></new-input>
              <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                         name="img"></edit-file>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import Checkbox from '@/components/edit-form/Checkbox'
  import {createNamespacedHelpers} from 'vuex'
  import Calendar from '../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data () {
      return {
        isLoaded: false,
        editorInstance: '',
        text: '',
        editor: null,
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField'
      ]),
      onSubmit () {
        let object = {};
        object['title.1'] = this.item.titleFirst;
        object['title.2'] = this.item.titleSecond;
        this.edit({
          img: this.item.img,
          url: this.item.url,
          object: JSON.stringify(object)
        })
      }
    },
    mounted () {
    },
    created () {
      this.resetModule()
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Описание страниц',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          titleFirst: {message: 'Заполните первую строку', hasError: false},
          titleSecond: {isNullable: true, hasError: false},
          url: {message: 'Введите ссылку', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then((response) => {
        if (response.object.hasOwnProperty('title.1')) this.setItemField({fieldName: 'titleFirst', value: response.object['title.1']});
        if (response.object.hasOwnProperty('title.2')) this.setItemField({fieldName: 'titleSecond', value: response.object['title.2']});
        this.isLoaded = true
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      Checkbox
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/description-pages/pages/Edit.vue